import React, {  useEffect,useCallback,useState } from 'react';
import { useSelector } from "react-redux"; 
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next" 
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box';  
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Textarea from '@mui/joy/Textarea';
import Typography from '@mui/material/Typography'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import "css/generalSettings.css";
import "css/customDialog.css";
import "css/empButtons.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp"; 
import { NumericFormat } from 'react-number-format';
import { setLoading } from 'reducers/loadingSlice';
import PropTypes from 'prop-types'; 

const initialStateStore = {
   "id":"",
  "documentid":"",
  "tradename":"",
  "name":"",
  "contacperson":"",
 "paymenttype_id":1,
  "paymenttype_code":"",
  "paymenttype_namees":"",
  "paymenttype_nameen":"",
  "comments":"",
  "phones" : [],
  "emails" : [],
  "addresses" : [],
  "bankaccounts" : [],
  "vehicles":[],
  "useraccounts":[] 
};
 
const TicketsViewStoreDetails = ({ id, openTicketsViewDetails,setOpenTicketsViewDetails}) => {
  const { t, i18n } = useTranslation(['listDataStores']);
  const token = useSelector((state) => state.loginUser.token);  
  const [formStore, setFormStore] = useState(initialStateStore);
  const [errorsStore, setErrorsStore] = useState({});

  const dispatch = useDispatch();
 
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && openTicketsViewDetails) {
        setFormStore(initialStateStore);
        setFormStore(formStore => ({
          ...formStore,
          phones:[],
          emails:[],
          addresses:[],
          bankaccounts:[],
          vehicles:[],
          useraccounts:[]
        }));
        setErrorsStore({});
        dispatch(setLoading(false));
        setOpenTicketsViewDetails(false);
      }
    },
    [ setFormStore, 
      setErrorsStore,
      dispatch, 
      openTicketsViewDetails, 
      setOpenTicketsViewDetails]
  );

  const closeModalViewDetails = () => { 
    setFormStore(initialStateStore);
    setFormStore(formStore => ({
      ...formStore,
      phones:[],
      emails:[],
      addresses:[],
      bankaccounts:[],
      vehicles:[],
      useraccounts:[]
    }));
    setErrorsStore({});
    dispatch(setLoading(false));
    setOpenTicketsViewDetails(false);
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]); 

   const toggleDrawerFormatDI = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      closeModalViewDetails();
      return;
    }
  };
 
  const handleChangeDataEditStore = (e) => {
    const { name, value } = e.target;
    setFormStore(formStore => ({
      ...formStore,
      [name]: value,
    }));
    setFormStore(formStore => ({
      ...formStore
    }));  
  };

  const handleBlurDataEditStore = (e) => {
    handleChangeDataEditStore(e);
    setErrorsStore(validateFormStore());
  };

  const validateFormStore = () => {
    let errorsStore = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (regexInvalidCharacters.test(formStore.comments)) {
      errorsStore.comments = 'Text_TextNoValid';
    } 
    return errorsStore;
  };

const handleSubmitDataEditStore = () => {
    const errors = validateFormStore(); 
    setErrorsStore(errors);
    if (Object.keys(errors).length === 0 && formStore.tradename !== '') {
      closeModalViewDetails();
      const fetchData = async () => {
        try {
          const getData = id !== "0" && await helpHttp().put(ENDPOINT, `ticketsdetails/updatestorecomments`, token, formStore);
          if (getData.status === "OK") {
            dispatch(successErrorAction(t('Text_SaveData')));
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }  
      }; 
      fetchData(); 
    } else {
      if (errors.comments) {
        dispatch(warningErrorAction(t(errors.comments)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    const fetchDataStore = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get2(ENDPOINT, `ticketsdetails/getviewdetailsstorebyid/`, token, id);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setFormStore(initialStateStore);
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setFormStore(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (openTicketsViewDetails){
      if (id !== "0") {
        fetchDataStore();
        dispatch(setLoading(false));
      }  
    }
    return () => { isMounted = false };
  
  }, [dispatch, id, t, token, formStore.id,setFormStore,openTicketsViewDetails]);

  return (
    <>
      {openTicketsViewDetails && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerFormatDI(false)}
            onOpen={toggleDrawerFormatDI(true)}
          >
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '900px' }}>
                <br/>
                {/* HEADER */}
                <div className="email-card-header">
                  <div className="email-header-content">
                    <div className="email-header-text">
                      <div className="email-header-title">
                          {t('Text_Data')}
                      </div>
                      <div className="email-header-number">
                        {formStore.tradename || '-'}
                      </div>
                    </div>
                    <div className="email-card-actions"> 
                      <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleSubmitDataEditStore} >
                        {t('Text_Save_Commens')}
                      </button> 
                      <button type="button" className="email-cancel-btn" onClick={closeModalViewDetails} >
                        {t('Button_Back')}
                      </button> 
                    </div>
                  </div>
                </div> 
                <br/> 
                <form onSubmit={closeModalViewDetails}> 
                  <div className="email-card-form">
                    <div className="card-body"> 
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_tradename').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {formStore.tradename || '-'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_documentid').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {formStore.documentid || '-'}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_name').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {formStore.name || '-'}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                           <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_Data_Contac').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {formStore.contacperson || '-'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_paymenttype').toUpperCase()}
                          </Typography>
                          <Typography style={{color:"black", fontSize: 18}}>
                            {formStore.paymenttype_namees || t('Text_NOT_REPORTING')}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}> 
                        </Grid>

                         <Grid item xs={6}>
                           <Divider sx={{ my: 2 }} />
                           <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_emails').toUpperCase()}
                          </Typography>
                          {formStore.emails!==undefined && formStore.emails!==null && formStore.emails && formStore.emails.length > 0 ? (
                            formStore.emails.map((emailObj, index) => (
                              <Typography key={index} style={{ color: "black", fontSize: 18 }}>
                                {emailObj.defaultemail || formStore.emails.length===1? '* ' : ''}{emailObj.email}
                              </Typography>
                            ))
                          ) : (
                            <Typography style={{ color: "gray", fontSize: 16 }}>
                              {t('Text_NOT_REPORTING')}
                            </Typography>
                          )} 
                        </Grid>
                         <Grid item xs={6}>
                           <Divider sx={{ my: 2 }} />
                           <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_phones').toUpperCase()}
                          </Typography>
                          {formStore.phones!==undefined && formStore.phones!==null && formStore.phones && formStore.phones.length > 0 ? (
                            formStore.phones.map((phoneObj, index) => (
                              <Typography key={index} style={{ color: "black", fontSize: 18 }}>
                                {phoneObj.defaultphone || formStore.phones.length===1? '* ' : ''}{phoneObj.phone}
                              </Typography>
                            ))
                          ) : (
                            <Typography style={{ color: "gray", fontSize: 16 }}>
                              {t('Text_NOT_REPORTING')}
                            </Typography>
                          )} 
                        </Grid>
                        <Grid item xs={12}>
                          <Divider sx={{ my: 2 }} />
                           <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_Address_Habitual').toUpperCase()}
                          </Typography>
                          {formStore.addresses!==undefined && formStore.addresses!==null && formStore.addresses && formStore.addresses.length > 0 ? (
                            formStore.addresses.map((addressObj, index) => (
                              <Typography key={index} style={{ color: "black", fontSize: 18 }}>
                                {addressObj.defaultaddress || formStore.addresses.length===1? '* ' : ''}{i18n.language==='es'?addressObj.roadtype_namees:addressObj.roadtype_nameen}&nbsp;{addressObj.street}&nbsp;-&nbsp;{addressObj.postalcode_postalcodename}
                              </Typography>
                            ))
                          ) : (
                            <Typography style={{ color: "gray", fontSize: 16 }}>
                              {t('Text_NOT_REPORTING')}
                            </Typography>
                          )} 
                        </Grid>
                        <Grid item xs={12}>
                          <Divider sx={{ my: 2 }} />
                           <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_Vehicles').toUpperCase()}: ({t('Text_Vehicle_checkpma').toUpperCase()} - {t('Text_Vehicle_licenseplate').toUpperCase()} - {t('Text_Vehicle_tara').toUpperCase()})
                          </Typography>
                          {formStore.vehicles!==undefined && formStore.vehicles!==null && formStore.vehicles && formStore.vehicles.length > 0 ? (
                            <Grid container spacing={2}>
                              {formStore.vehicles.map((vehiclesObj, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                  <Typography style={{ color: "black", fontSize: 18 }}>
                                    <Checkbox 
                                      checked={vehiclesObj.checkpma} 
                                      sx={{
                                        '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 28 },
                                      }} 
                                      disabled 
                                    />
                                    &nbsp;-&nbsp;{vehiclesObj.defaultvehicle || formStore.vehicles.length === 1 ? '* ' : ''}{vehiclesObj.licenseplate}&nbsp;-&nbsp;
                                      <NumericFormat
                                        style={{color:"black", align:'right', fontSize: 18}}
                                        thousandSeparator={','} 
                                        decimalSeparator={'.'} 
                                        decimalScale= {2}
                                        fixedDecimalScale= {true}
                                        displayType="text"
                                        value={vehiclesObj.tara}
                                        disabled={true}
                                      >           
                                    </NumericFormat>
                                   
                                  </Typography>
                                </Grid>
                              ))}
                            </Grid> 
                          ) : (
                            <Typography style={{ color: "gray", fontSize: 16 }}>
                              {t('Text_NOT_REPORTING')}
                            </Typography>
                          )} 
                        </Grid>

                        <Grid item xs={12}>
                          <Divider sx={{ my: 2 }} />
                           <Typography style={{color:"#4e73df", fontSize: 16}}>
                            {t('Text_Comments').toUpperCase()}
                          </Typography>
                          <Textarea 
                            id="comments" 
                            name="comments"
                            value={formStore.comments }
                            label={errorsStore.comments!=null?t(errorsStore.comments):t('PlaceHolder_Comments')}
                            placeholder={t('PlaceHolder_Comments')}
                            sx={{width: 860, fontSize: 18} }
                            variant="standard"
                            onBlur={handleBlurDataEditStore}
                            onChange={handleChangeDataEditStore}
                            maxRows={8}
                          />   
                        </Grid>
                      </Grid> 
                    </div> 
                  </div>
                </form>
              </Box>
            </Container>
          </SwipeableDrawer>    
        </div>
      } 
    </>
  )
}

TicketsViewStoreDetails.propTypes = {
  openTicketsViewDetails: PropTypes.bool.isRequired,
  setOpenTicketsViewDetails: PropTypes.func.isRequired
};

export default TicketsViewStoreDetails;